// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3wc0TIvVjda3n_klo390Nz"};